import React from "react"
import "./index.css"

const SettingsButton = ({ children, ...props }) => (
  <button className={"settingsButton"} {...props}>{children}</button>
)

export default SettingsButton



// WEBPACK FOOTER //
// ./src/components/settings-button/SettingsButton.js